import { render, staticRenderFns } from "./LabelConfiguration.vue?vue&type=template&id=1f8e5be4&scoped=true"
import script from "./LabelConfiguration.vue?vue&type=script&lang=ts&setup=true"
export * from "./LabelConfiguration.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LabelConfiguration.vue?vue&type=style&index=0&id=1f8e5be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e5be4",
  null
  
)

export default component.exports